import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import MedicalIcon from '../../icons/MedicalIcon';
import { loadCourseTemplateHealthDetails } from '../../store/directusService';
import { getNameFromId } from '../../utils/directusFunctions';

import local from './healthInfo.module.css';

const HealthInfo = ({ healthInformationCaptured, healthInformationIds }) => {
    const dispatch = useDispatch();

    // LOCAL STATE
    const [names, setNames] = useState([]);

    // STORE STATE
    const courseTemplateHealthDetails = useSelector(
        (state) => state.entities.directusService.courseTemplateHealthDetails
    );

    // USEEFFECTS
    useEffect(() => {
        courseTemplateHealthDetails?.length < 1 && dispatch(loadCourseTemplateHealthDetails());
    }, []);

    useEffect(() => {
        if (courseTemplateHealthDetails?.length < 1) return;
        const names = healthInformationIds
            .map((el) => getNameFromId(courseTemplateHealthDetails, el))
            .filter((el) => el);
        setNames(names);
    }, [courseTemplateHealthDetails]);

    // RENDER
    return (
        <div className={local.healthInfo} data-testid="template_health_info">
            <MedicalIcon />
            <div>
                <span> Health Information Required </span>
                {healthInformationCaptured && (
                    <>
                        <span className={local.spacer}> - </span>
                        {names.map((el) => el).join(', ')}
                    </>
                )}
            </div>
        </div>
    );
};

HealthInfo.propTypes = {
    healthInformationCaptured: PropTypes.bool.isRequired,
    healthInformationIds: PropTypes.arrayOf(PropTypes.string)
};

export default HealthInfo;
